import React, {useState, useEffect} from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import api from '../../services/api';
import NumberFormat from 'react-number-format';

import {
  HeaderPage,
  TitlePage,
  SubTitlePage,
  PlanCard,
  PlanCardHeader,
  PlanCardHeaderTitle,
  PlanCardHeaderValue,
  PlanCardDetailTxt,
  PlanCardInfor,
  PlanCardObs,
  PlanCardFooter,
  PlanCardBtn,
  PlanPageBody,
  LoaderContainer,
  PlanCardDetailTxtStrong,
} from "./styles";

export default function Plans() {
  const [plans, setPlans] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchPlans = async () => {
    try {
      setIsLoading(true);
      const result = await api.get('/plans');
      const {data} = result;

      console.log(result);
      setPlans(data);
      setIsLoading(false);
    } catch (err) {
      console.log(err.response);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchPlans();
  }, []);


  return (
      <PlanPageBody>
     <Container>
    <HeaderPage>
      <TitlePage>Nossos Planos</TitlePage>
      <SubTitlePage>
        Temos o plano perfeito para você. Veja logo abaixo !
      </SubTitlePage>
    </HeaderPage>
    { isLoading && (
      <LoaderContainer>
        <Spinner animation="grow" variant="dark" />
      </LoaderContainer>
    )}

    { plans && plans.length === 0 && (
      <LoaderContainer>
        <h6>Não existe dados a serem exibidos.</h6>
      </LoaderContainer>
    )}

    { !isLoading && plans && (

        <Row>
        {plans.map((plan, index) => (
          <Col xs={12} md={4} key={index}>
            <PlanCard>
              <PlanCardHeader>
                <PlanCardHeaderTitle>
                  {plan.name}
                </PlanCardHeaderTitle>
                <PlanCardHeaderValue><NumberFormat fixedDecimalScale={true} decimalScale={2} value={plan.amount_1_life} displayType={'text'} thousandSeparator="." isNumericString={true} decimalSeparator={','} prefix={'R$ '} /></PlanCardHeaderValue>
              </PlanCardHeader>
              <PlanCardInfor>{plan.description}</PlanCardInfor>
              <PlanCardDetailTxt>
                Para saber mais,<a href={plan.detail_url} target="_blank"><PlanCardDetailTxtStrong>clique aqui !</PlanCardDetailTxtStrong></a>
              </PlanCardDetailTxt>
              <PlanCardObs>
                OBS.: Valor por pessoa. Para planos com 2 ou mais pessoas, terá
                descontos progressivos de acordo com a quantidade.
              </PlanCardObs>
              <PlanCardFooter>
                <Link to={`/proposal?planId=${plan._id}`}>
                  <PlanCardBtn>Contratar</PlanCardBtn>
                </Link>
              </PlanCardFooter>
            </PlanCard>
          </Col>
        ))}
      </Row>

    )}
    </Container>
      </PlanPageBody>
  );
}
